/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { RallyComponent } from './rally/rally.component';
import { RallyStartComponent } from './rally-start/rally-start.component';

import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { SharedUtilityComponentsModule } from 'src/app/common/utility-components/shared-utility-components.module';

import routes from './rally-route-config';
import { MaterialModule } from '../material/material-module';
import { PresentationModule } from '../presentation-components/presentation.module';

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		RouterModule,
		ReactiveFormsModule,
		SharedUIMaterialModule,
		SharedUtilityComponentsModule,
		MaterialModule,
		PresentationModule,
	],
	declarations: [RallyComponent, RallyStartComponent],
	exports: [RouterModule, RallyComponent, RallyStartComponent],
	providers: [],
})
export class RallyPointModule {}
